<app-navbar></app-navbar>
<app-alert-banner></app-alert-banner>
<app-loading></app-loading>
<router-outlet></router-outlet>
<button-scroll-to-top></button-scroll-to-top>
<app-footer></app-footer>
<app-cookies-notice></app-cookies-notice>
